import Vue from 'vue';
import VueResource from 'vue-resource';
Vue.use(VueResource);

import MainVue from '../../../main-vue-bn';

new MainVue({
    el: '#bn-app',
    data: function () {
        return {
            name: ''
        }
    }
});